export const APP_STATE_ACTIONS = {
  HELP_TEXT: "HELP_TEXT",
  TOAST_MESSAGE: "TOAST_MESSAGE",
  PG_BANNER_MESSAGE: "PG_BANNER_MESSAGE",
  BOX_BANNER_MESSAGE: "BOX_BANNER_MESSAGE",
  MODAL_MESSAGE: "MODAL_MESSAGE",
};

export const appStateI = {
  show_help_text: false,
  show_toast_message: false,
  toast_message_data: {},
  show_pg_banner_message: false,
  pg_banner_message_data: {},
  show_box_banner_message: false,
  box_banner_message_data: {},
  show_modal_message: false,
  modal_message_data: {},
};

export const appStateReducer = (state: any, action: any) => {
  switch (action.type) {
    case APP_STATE_ACTIONS.HELP_TEXT:
      return { ...state, show_help_text: !state.show_help_text };
    case APP_STATE_ACTIONS.TOAST_MESSAGE:
      return {
        ...state,
        show_toast_message: action?.show ?? false,
        toast_message_data: action?.data ?? {},
      };
    case APP_STATE_ACTIONS.PG_BANNER_MESSAGE:
      return {
        ...state,
        show_pg_banner_message: action?.show ?? false,
        pg_banner_message_data: action?.data ?? {},
      };
    case APP_STATE_ACTIONS.BOX_BANNER_MESSAGE:
      return {
        ...state,
        show_box_banner_message: action?.show ?? false,
        box_banner_message_data: action?.data ?? {},
      };
    case APP_STATE_ACTIONS.MODAL_MESSAGE:
      return {
        ...state,
        show_modal_message: action?.show ?? false,
        modal_message_data: action?.data ?? {},
      };
    default:
      return state;
  }
};
